import { render, staticRenderFns } from "./EmptyContent.vue?vue&type=template&id=547549df&scoped=true"
import script from "./EmptyContent.vue?vue&type=script&lang=ts"
export * from "./EmptyContent.vue?vue&type=script&lang=ts"
import style0 from "./EmptyContent.vue?vue&type=style&index=0&id=547549df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "547549df",
  null
  
)

export default component.exports